
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-transcripts/[video]",
      function () {
        return require("private-next-pages/video-transcripts/[video].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-transcripts/[video]"])
      });
    }
  